import videoMaterials from '@/assets/video';
import ColorOverlay from '@/components/atoms/ColorOverlay';
import Header from '@/components/molecules/Header';
import HeroBackgroundVideo from '@/components/molecules/HeroBackgroundVideo';
import { HEADER_HEIGHT } from '@/constants/dimensions';
import useIsWeb from '@/hooks/useIsWeb';
import { Flex, Image, Stack, Text, VStack } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

type Props = {
  title?: string;
  heroChildren: React.ReactNode;
  heroChildrenTopMargin?: number;
  backgroundOverlay?: string;
  backgroundOverlayOpacity?: number;
  isBackgroundFixed?: boolean;
};

// Just a template for a page with a hero background video
// heroChildren is the children of the hero section - FORM
// children is the children of the page - BELOW VIDEO BACKGROUND
const HeroBackgroundPage = ({
  children,
  title,
  heroChildren,
  heroChildrenTopMargin = HEADER_HEIGHT / 2,
  backgroundOverlay,
  backgroundOverlayOpacity = 1,
  isBackgroundFixed = false,
}: PropsWithChildren<Props>) => {
  const isWeb = useIsWeb();
  const backgroundPosition = isBackgroundFixed ? 'fixed' : 'absolute';

  return (
    <Flex width={'100%'} direction={'column'} alignItems={'center'} top={0}>
      <Header variant="transparent" isSticky={false} />
      <VStack width={'100vw'} height={'100vh'}>
        {isWeb ? (
          <HeroBackgroundVideo position={backgroundPosition} />
        ) : (
          <VStack height={'100vh'} width={'100vw'} position={backgroundPosition} inset={0}>
            <Image
              src={videoMaterials.manMeditatingPoster}
              alt="video-poster"
              objectFit={'cover'}
              style={{ width: '100vw', height: '100vh' }}
            />
            <ColorOverlay color1={'#1A00B9'} height={'100vh'} />
          </VStack>
        )}
        {backgroundOverlay ? (
          <Flex
            position={backgroundPosition}
            top={0}
            width={'100%'}
            height={'100vh'}
            background={backgroundOverlay}
            opacity={backgroundOverlayOpacity}
          />
        ) : null}
        <Flex
          flexDirection="column"
          width="100wh"
          minHeight="100vh"
          justifyContent="center"
          alignItems="center"
          position={'absolute'}
          marginTop={{ base: heroChildrenTopMargin, xl: 0 }}
        >
          <Stack flexDir="column" justifyContent="center" alignItems="center">
            <Text variant="loraTitle" color="white" fontSize={'26px'}>
              {title}
            </Text>
            {heroChildren}
          </Stack>
        </Flex>
      </VStack>
      {children}
    </Flex>
  );
};

export default HeroBackgroundPage;
